export function initPhotoSliderBlocks() {
	const blocks = document.querySelectorAll('[data-photo-slider]');
	if (!blocks.length) {
		return;
	}

	blocks.forEach((block) => {
		initPhotoSliderBlock(block);
	});
}

function initPhotoSliderBlock(block) {
	const track = block.querySelector('[data-photo-track]');
	const prevButton = block.querySelector('[data-photo-prev]');
	const nextButton = block.querySelector('[data-photo-next]');
	if (!track || !prevButton || !nextButton) {
		return;
	}

	const getSlides = () => Array.from(track.querySelectorAll('.photo-slider-block__slide'));

	const getSlideLeft = (slide) => {
		const trackRect = track.getBoundingClientRect();
		const slideRect = slide.getBoundingClientRect();
		return track.scrollLeft + (slideRect.left - trackRect.left);
	};

	const getColumnPositions = () => {
		const slides = getSlides();
		if (!slides.length) return [];

		const positions = slides.map((slide) => Math.max(0, Math.round(getSlideLeft(slide))));
		const uniquePositions = Array.from(new Set(positions));
		uniquePositions.sort((a, b) => a - b);

		return uniquePositions;
	};

	const getCurrentColumnIndex = (positions) => {
		if (!positions.length) return -1;
		const current = track.scrollLeft;
		let closestIndex = 0;
		let minDistance = Number.POSITIVE_INFINITY;

		positions.forEach((position, index) => {
			const distance = Math.abs(position - current);
			if (distance < minDistance) {
				minDistance = distance;
				closestIndex = index;
			}
		});

		return closestIndex;
	};

	const updateNavState = () => {
		const positions = getColumnPositions();
		if (!positions.length) {
			prevButton.disabled = true;
			nextButton.disabled = true;
			return;
		}

		const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
		if (maxScroll <= 2) {
			prevButton.disabled = true;
			nextButton.disabled = true;
			return;
		}

		const currentIndex = getCurrentColumnIndex(positions);
		prevButton.disabled = currentIndex <= 0;
		nextButton.disabled = currentIndex >= positions.length - 1;
	};

	const scrollToSibling = (direction) => {
		const positions = getColumnPositions();
		if (!positions.length) {
			return;
		}

		const currentIndex = getCurrentColumnIndex(positions);
		if (currentIndex < 0) {
			return;
		}

		const delta = direction > 0 ? 1 : -1;
		const targetIndex = Math.min(Math.max(currentIndex + delta, 0), positions.length - 1);
		const targetLeft = positions[targetIndex];
		track.scrollTo({ left: Math.max(0, targetLeft), behavior: 'smooth' });
	};

	prevButton.addEventListener('click', () => {
		scrollToSibling(-1);
	});

	nextButton.addEventListener('click', () => {
		scrollToSibling(1);
	});

	track.addEventListener('scroll', updateNavState, { passive: true });
	window.addEventListener('resize', updateNavState);

	updateNavState();
}
